"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var Account_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Account = exports.AccountEventsEnum = exports.CompanyTypeEnum = void 0;
const typeorm_1 = require("typeorm/browser");
const affiliate_id_1 = require("./affiliate-id");
const contact_1 = require("./contact");
const rejected_brand_1 = require("./rejected-brand");
const job_1 = require("./job");
const base_account_1 = require("./base-account");
const account_status_enum_1 = require("./account-status-enum");
const opportunity_1 = require("./opportunity");
const decorators_1 = require("../data-ui/decorators");
const contact_profile_enum_1 = require("./contact-profile-enum");
const layouts_1 = require("../data-ui/layouts");
const events_1 = require("../events");
const onboarding_step_enum_1 = require("./onboarding-step-enum");
const account_profile_1 = require("./account-profile");
var CompanyTypeEnum;
(function (CompanyTypeEnum) {
    CompanyTypeEnum["EG"] = "eG";
    CompanyTypeEnum["EINZELUNTERNEHMEN"] = "Einzelunternehmen";
    CompanyTypeEnum["GBR"] = "GbR";
    CompanyTypeEnum["GMBH"] = "GmbH";
    CompanyTypeEnum["GMBH_AND_CO_KG"] = "GmbH & Co. KG";
    CompanyTypeEnum["KG"] = "KG";
    CompanyTypeEnum["OHG"] = "oHG";
    CompanyTypeEnum["UG"] = "UG";
    CompanyTypeEnum["UG_AND_COKG"] = "UG & Co.KG";
    CompanyTypeEnum["AG"] = "AG";
    CompanyTypeEnum["_inactive_OTHER"] = "andere";
    CompanyTypeEnum["_inactive_EINZELUNTERNEHMER"] = "Einzelunternehmer";
})(CompanyTypeEnum = exports.CompanyTypeEnum || (exports.CompanyTypeEnum = {}));
var AccountEventsEnum;
(function (AccountEventsEnum) {
    AccountEventsEnum["STATUS_CHANGE"] = "status_change";
})(AccountEventsEnum = exports.AccountEventsEnum || (exports.AccountEventsEnum = {}));
let Account = Account_1 = class Account extends base_account_1.BaseAccount {
};
Account.EVENTS = (0, events_1.makeEventsForClass)(Account_1, AccountEventsEnum);
Account.SFID_PREFIX = '001';
__decorate([
    (0, typeorm_1.Index)('idx_trgm_account_eid', { synchronize: false }),
    (0, typeorm_1.Column)('character varying', {
        length: 255,
        nullable: true,
        name: 'eid__c',
    }),
    __metadata("design:type", String)
], Account.prototype, "eid", void 0);
__decorate([
    decorators_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_FORM),
    (0, typeorm_1.Column)('character varying', {
        nullable: true,
        length: 18,
        name: 'parentid',
    }),
    __metadata("design:type", String)
], Account.prototype, "parentId", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        nullable: true,
        length: 80,
        name: 'emailforinvoices__c',
    }),
    __metadata("design:type", String)
], Account.prototype, "emailForInvoices", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        nullable: true,
        length: 255,
        name: 'supplier_id__c',
    }),
    __metadata("design:type", String)
], Account.prototype, "supplierId", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        nullable: true,
        length: 255,
        name: 'umsatzsteuerid__c',
    }),
    __metadata("design:type", String)
], Account.prototype, "vatId", void 0);
__decorate([
    (0, typeorm_1.Column)('boolean', {
        nullable: true,
        name: 'umsatzsteuer_befreit__c',
    }),
    __metadata("design:type", Boolean)
], Account.prototype, "vatExempt", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        nullable: true,
        length: 25,
        name: 'tax_no__c',
    }),
    __metadata("design:type", String)
], Account.prototype, "taxId", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'enum',
        enum: CompanyTypeEnum,
        nullable: true,
        name: 'companytype__c',
    }),
    __metadata("design:type", String)
], Account.prototype, "companyType", void 0);
__decorate([
    (0, typeorm_1.Column)('double precision', {
        name: 'debitor_number__c',
        nullable: true,
    }),
    __metadata("design:type", Number)
], Account.prototype, "debitorNumber", void 0);
__decorate([
    (0, typeorm_1.Column)('double precision', {
        name: 'creditor_number__c',
        nullable: true,
    }),
    __metadata("design:type", Number)
], Account.prototype, "creditorNumber", void 0);
__decorate([
    (0, typeorm_1.Index)(),
    (0, typeorm_1.Column)({
        type: 'enum',
        enum: account_status_enum_1.AccountStatusEnum,
        default: account_status_enum_1.AccountStatusEnum.NEW,
        name: 'accountstatus__c',
    }),
    __metadata("design:type", String)
], Account.prototype, "status", void 0);
__decorate([
    decorators_1.DataUi.EnumValuesFromPicklist('Transporter', true),
    (0, typeorm_1.Column)('character varying', {
        name: 'transporter__c',
        nullable: true,
        length: 4099,
    }),
    __metadata("design:type", String)
], Account.prototype, "transporter", void 0);
__decorate([
    decorators_1.DataUi.Override({ label: 'HwO A' }),
    decorators_1.DataUi.EnumValuesFromPicklist('HwO_A', true),
    (0, typeorm_1.Column)('character varying', {
        name: 'hwo_a__c',
        nullable: true,
        length: 4099,
    }),
    __metadata("design:type", String)
], Account.prototype, "hwoA", void 0);
__decorate([
    decorators_1.DataUi.Override({ label: 'HwO B1' }),
    decorators_1.DataUi.EnumValuesFromPicklist('HwO_B1', true),
    (0, typeorm_1.Column)('character varying', {
        name: 'hwo_b__c',
        nullable: true,
        length: 4099,
    }),
    __metadata("design:type", String)
], Account.prototype, "hwoB1", void 0);
__decorate([
    decorators_1.DataUi.Override({ label: 'HwO B2' }),
    decorators_1.DataUi.EnumValuesFromPicklist('HwO_B2', true),
    (0, typeorm_1.Column)('character varying', {
        name: 'hwo_b2__c',
        nullable: true,
        length: 4099,
    }),
    __metadata("design:type", String)
], Account.prototype, "hwoB2", void 0);
__decorate([
    decorators_1.DataUi.Override({ label: 'Nicht HwO' }),
    decorators_1.DataUi.EnumValuesFromPicklist('nicht_HwO', true),
    (0, typeorm_1.Column)('character varying', {
        name: 'nicht_hwo__c',
        nullable: true,
        length: 4099,
    }),
    __metadata("design:type", String)
], Account.prototype, "noHwo", void 0);
__decorate([
    decorators_1.DataUi.Override({ label: 'Brand training' }),
    decorators_1.DataUi.EnumValuesFromPicklist('Weiterbildung', true),
    (0, typeorm_1.Column)('character varying', {
        name: 'weiterbildung__c',
        nullable: true,
        length: 4099,
    }),
    __metadata("design:type", String)
], Account.prototype, "additionalEducation", void 0);
__decorate([
    decorators_1.DataUi.Override({ label: 'Zusatzqualifikation' }),
    decorators_1.DataUi.EnumValuesFromPicklist('Zertifikat_Zusatzqualifikation', true),
    (0, typeorm_1.Column)('character varying', {
        name: 'zusatzqualifikation__c',
        nullable: true,
        length: 4099,
    }),
    __metadata("design:type", String)
], Account.prototype, "additionalQualification", void 0);
__decorate([
    (0, typeorm_1.Column)('double precision', {
        nullable: true,
        name: 'servicearea__c',
    }),
    __metadata("design:type", Number)
], Account.prototype, "serviceArea", void 0);
__decorate([
    (0, typeorm_1.Column)('boolean', {
        name: 'bypass_local_prio_delay',
        default: false,
        nullable: false,
    }),
    __metadata("design:type", Boolean)
], Account.prototype, "bypassLocalPrioDelay", void 0);
__decorate([
    (0, typeorm_1.Column)('boolean', {
        name: 'prevent_auto_create_job',
        default: false,
        nullable: false,
    }),
    __metadata("design:type", Boolean)
], Account.prototype, "preventAutoCreateJob", void 0);
__decorate([
    decorators_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_TABLE),
    decorators_1.DataUi.Override({ label: 'Restricted Protocol Submission' }),
    (0, typeorm_1.Column)('boolean', {
        name: 'restrict_protocol_submission',
        nullable: true,
    }),
    __metadata("design:type", Boolean)
], Account.prototype, "restrictProtocolSubmission", void 0);
__decorate([
    (0, typeorm_1.CreateDateColumn)({
        type: 'timestamp without time zone',
        name: 'createddate',
    }),
    __metadata("design:type", Date)
], Account.prototype, "createdAt", void 0);
__decorate([
    (0, typeorm_1.UpdateDateColumn)({
        type: 'timestamp without time zone',
        name: 'lastmodifieddate',
    }),
    __metadata("design:type", Date)
], Account.prototype, "updatedAt", void 0);
__decorate([
    decorators_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_TABLE),
    (0, typeorm_1.Column)({
        type: 'enum',
        enum: onboarding_step_enum_1.OnboardingStepEnum,
        array: true,
        default: '{}',
    }),
    __metadata("design:type", Array)
], Account.prototype, "completedOnboardingSteps", void 0);
__decorate([
    decorators_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_TABLE),
    (0, typeorm_1.Column)('character varying', {
        nullable: true,
    }),
    __metadata("design:type", String)
], Account.prototype, "installerIdNumber", void 0);
__decorate([
    decorators_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_TABLE),
    (0, typeorm_1.Column)('character varying', {
        nullable: true,
    }),
    __metadata("design:type", String)
], Account.prototype, "networkOperator", void 0);
__decorate([
    (0, typeorm_1.Index)(),
    (0, typeorm_1.ManyToOne)((type) => Account_1, (account) => account.childAccounts),
    (0, typeorm_1.JoinColumn)({
        name: 'parentid',
    }),
    __metadata("design:type", Account)
], Account.prototype, "parentAccount", void 0);
__decorate([
    (0, typeorm_1.OneToMany)((type) => Account_1, (account) => account.parentAccount),
    __metadata("design:type", Array)
], Account.prototype, "childAccounts", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)((type) => Account_1, (account) => account.invoiceAccounts),
    (0, typeorm_1.JoinColumn)({
        name: 'invoicerecipient__c',
    }),
    __metadata("design:type", Account)
], Account.prototype, "invoiceAccount", void 0);
__decorate([
    (0, typeorm_1.OneToMany)((type) => Account_1, (account) => account.invoiceAccounts),
    __metadata("design:type", Array)
], Account.prototype, "invoiceAccounts", void 0);
__decorate([
    (0, typeorm_1.OneToMany)(() => contact_1.Contact, (contact) => contact.account),
    __metadata("design:type", Array)
], Account.prototype, "contacts", void 0);
__decorate([
    (0, typeorm_1.OneToMany)(() => rejected_brand_1.RejectedBrand, (rejectedBrands) => rejectedBrands.brand),
    __metadata("design:type", Array)
], Account.prototype, "rejectedBrands", void 0);
__decorate([
    decorators_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_FORM),
    (0, typeorm_1.OneToMany)(() => job_1.Job, (job) => job.brand),
    __metadata("design:type", Array)
], Account.prototype, "brandJobs", void 0);
__decorate([
    decorators_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_FORM),
    (0, typeorm_1.OneToMany)(() => job_1.Job, (job) => job.partner),
    __metadata("design:type", Array)
], Account.prototype, "partnerJobs", void 0);
__decorate([
    (0, typeorm_1.OneToMany)(() => job_1.Job, (job) => job.customer),
    __metadata("design:type", Array)
], Account.prototype, "customerJobs", void 0);
__decorate([
    (0, typeorm_1.OneToMany)(() => affiliate_id_1.AffiliateId, (affiliateId) => affiliateId.affiliateAccount),
    __metadata("design:type", Array)
], Account.prototype, "affiliateIds", void 0);
__decorate([
    (0, typeorm_1.OneToMany)(() => opportunity_1.Opportunity, (opportunity) => opportunity.brand),
    __metadata("design:type", Array)
], Account.prototype, "opportunities", void 0);
__decorate([
    (0, typeorm_1.OneToMany)(() => account_profile_1.AccountProfile, (profile) => profile.account),
    __metadata("design:type", Array)
], Account.prototype, "profiles", void 0);
__decorate([
    (0, typeorm_1.Column)({ type: 'boolean', default: false }),
    __metadata("design:type", Boolean)
], Account.prototype, "hasAcceptedTerms", void 0);
__decorate([
    (0, typeorm_1.Column)({ type: 'timestamp without time zone', nullable: true }),
    __metadata("design:type", Date)
], Account.prototype, "termsAcceptedAt", void 0);
__decorate([
    (0, typeorm_1.Column)({ type: 'boolean', default: false }),
    __metadata("design:type", Boolean)
], Account.prototype, "hasAcceptedMarketingConsent", void 0);
__decorate([
    (0, typeorm_1.Column)({ type: 'timestamp without time zone', nullable: true }),
    __metadata("design:type", Date)
], Account.prototype, "marketingConsentAcceptedAt", void 0);
Account = Account_1 = __decorate([
    decorators_1.DataUi.Permissions({
        read: [
            contact_profile_enum_1.ContactProfileEnum.CUSTOMER_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.PARTNER_ONBOARDING,
            contact_profile_enum_1.ContactProfileEnum.BRAND_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.GID,
            contact_profile_enum_1.ContactProfileEnum.PARTNER_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.FINANCE,
            contact_profile_enum_1.ContactProfileEnum.FINANCE_POWER_USER,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT_POWER_USER,
        ],
        write: [
            contact_profile_enum_1.ContactProfileEnum.CUSTOMER_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.PARTNER_ONBOARDING,
            contact_profile_enum_1.ContactProfileEnum.BRAND_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.PARTNER_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.FINANCE_POWER_USER,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT_POWER_USER,
        ],
    }),
    decorators_1.DataUi.Name({
        name: 'Account',
        nameProperties: ['name'],
    }),
    decorators_1.DataUi.DefaultLayoutConfig(layouts_1.HIDE_IN_TABLE),
    (0, typeorm_1.Entity)('account', { schema: 'public', synchronize: true })
], Account);
exports.Account = Account;
//# sourceMappingURL=account.js.map